import { render, staticRenderFns } from "./ModuleInstaller.vue?vue&type=template&id=0f482a86"
import script from "./ModuleInstaller.vue?vue&type=script&lang=js"
export * from "./ModuleInstaller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f482a86')) {
      api.createRecord('0f482a86', component.options)
    } else {
      api.reload('0f482a86', component.options)
    }
    module.hot.accept("./ModuleInstaller.vue?vue&type=template&id=0f482a86", function () {
      api.rerender('0f482a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/modulos/aspectos/ModuleInstaller.vue"
export default component.exports